import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Account } from '../../../../../../../../shared/models';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../../../../state/app.state';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../../../../../../../shared/services/common.service';
import { ProjectsService } from '../../../../../../core/projects.service';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../../../../../../../shared/services';
import { takeUntil } from 'rxjs/operators';
import { FetchLineageRequest, FetchReportRequest } from '../../../../../../core/projects.actions';
import { environment } from '../../../../../../../../../environments/environment';
import { lineageList, reportInfo } from '../../../../../../core/projects.selectors';
import { ChangeOrdersRequestReportComponent } from '../change-orders-request-report/change-orders-request-report.component';

@Component({
    selector: 'app-change-orders-request-workflow',
    templateUrl: './change-orders-request-workflow.component.html',
    styleUrls: ['./change-orders-request-workflow.component.scss'],
    standalone: false
})
export class ChangeOrdersRequestWorkflowComponent implements OnInit, OnDestroy {
  @Input() data;
  reportTitle: any;
  timelineSteps: any[];
  createdBy: void;
  account: Account;
  name: string;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<fromRoot.State>,
    public route: ActivatedRoute,
    public router: Router,
    public commonService: CommonService,
    public projectsService: ProjectsService,
    public daily: CommonService,
    public dialog: MatDialog,
    public authService: AuthService,
  ) {
  }

  ngOnInit() {
    this.projectsService.createRequest
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.data = data?.data;
      });

    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        if (qp && qp['snSubTab'] === 'workflow') {
          this.store.dispatch(FetchLineageRequest({
            payload: {
              qp: {
                start: 0,
                total: 1000,
                ex: `change-order-approval/${this.data?.id}`,
                include: ['actor', 'state'],
              },
            },
          }));

          this.store.dispatch(FetchReportRequest({
            payload: {
              url: `${environment.API_ENDPOINT}${this.data?.reportUrl}`,
            },
          }));
        }
      });

    this.projectsService.openReport
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.openReport();
      });

    this.store.select(reportInfo)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.reportTitle = data?.title;
      });

    this.account = this.authService.getCurrentUser();

    this.store.select(lineageList)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.timelineSteps = data?.map(step => ({
          ...step,
          actorName: this.getName(step),
          icon: this.getIcon(step),
          approved: step?.state?.name === 'change-order-request-approve',
          submitForApproval: step?.state?.name === 'change-order-request-submit',
        }));
      });
  }

  getIcon(data: any) {
    const comment = data?.state?.comment;
    if (typeof comment === 'string' && comment.toLowerCase().includes('reject')) {
      return 'reject';
    } else {
      return 'correct';
    }
  }

  getName(data) {
    const name = `${data?.actor?.first_name} ${data?.actor?.last_name}`;

    if (name === this.account.name) {
      return 'You';
    } else {
      return name;
    }
  }

  openReport() {
    this.dialog.open(ChangeOrdersRequestReportComponent, {
      width: '1000px',
      height: '1100px',
      data: {
        ...this.data,
      },
    });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
